'use client';

import { useEffect } from "react";
import useReferral from "../_hooks/useReferral";

export const ReferralSystem = () => {
    const { setReferral } = useReferral();

    useEffect(() => {
        setReferral();
    }, [setReferral]); 

    return null;
}
